import {useDispatch, useSelector} from 'react-redux';
import { goBack } from 'connected-react-router'
import React, { useEffect } from 'react';
import InternalAlertForm from '../../components/InternalAlerts/internalAlertForm';
import {requestLawsysFirmGroup} from "../../actions/lawsysFirms";
import { changeInternalAlertFormData, getSolicitorGroupCaseTypes } from '../../reducers/internalAlertForm';


const InternalAlertsFormHOC = (props) => {
    const {handleSubmit,isEdit,handleDelete} = props;

const dispatch = useDispatch();
const manageSolicitorAccount = useSelector(state => state.manageSolicitorAccount);
const user = useSelector(state => state.user);
const internalAlerts = useSelector(state => state.internalAlerts);
const internalAlertForm = useSelector(state => state.internalAlertForm);
const lawsysFirms = useSelector(state => state.lawsysFirms);
const groups = useSelector(state => state.groups);

    useEffect(()=>{
            dispatch(requestLawsysFirmGroup({id:internalAlertForm.formData.solicitorFirmId}));
    },[internalAlertForm.formData.solicitorFirmId])

    useEffect(()=>{
            dispatch(getSolicitorGroupCaseTypes(lawsysFirms.solicitorGroup.id));

    },[lawsysFirms.solicitorGroup])
    

return(
    <InternalAlertForm
    isEdit={isEdit}
    solicitorGroup={lawsysFirms.solicitorGroup}
    lawsysFirms={lawsysFirms}
    changeFormData={(key,value) => dispatch(changeInternalAlertFormData({key,value}))}
    formData={internalAlertForm.formData}
    handleSubmit={handleSubmit}
    handleDelete={handleDelete}
    manageSolicitorAccount={manageSolicitorAccount}
    user={user}
    internalAlerts={internalAlerts}
    internalAlertForm={internalAlertForm}
    groups={groups}
    goBack={() => dispatch(goBack())}
    />
)
};
export default InternalAlertsFormHOC;